import { render, staticRenderFns } from "./ObjectSroDetail.vue?vue&type=template&id=2d27e32c"
import script from "./ObjectSroDetail.vue?vue&type=script&lang=js"
export * from "./ObjectSroDetail.vue?vue&type=script&lang=js"
import style0 from "./ObjectSroDetail.vue?vue&type=style&index=0&id=2d27e32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports